"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const lodash_1 = require("lodash");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const utils_1 = require("../../utils");
const LabelCards_1 = __importDefault(require("../LabelCards"));
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Backspace"] = 8] = "Backspace";
    KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
})(KeyCodes || (KeyCodes = {}));
// eslint-disable-next-line max-lines-per-function
function CustomLabelCard({ identifier = '', text = '', defaultPosition, editable, locked, trigger, setOffsetChanged, setShowLabelLines = lodash_1.noop, }) {
    const { isDesktop } = (0, device_1.usePlatform)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const { selectedLabelID } = (0, hooks_1.useLabels)();
    const [isEditing, setEditing] = (0, react_1.useState)(false);
    const [isExpanded, setExpanded] = (0, react_1.useState)(false);
    const [topOffset, setTopOffset] = (0, react_1.useState)(0);
    const textRef = (0, react_1.useRef)(null);
    const localTextRef = (0, react_1.useRef)(text);
    const isSelected = identifier === selectedLabelID;
    const tools = (0, providers_1.useToolsService)();
    const labelManager = tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager();
    const latestLabel = (0, hooks_1.useLatestLabel)();
    const cardRef = (0, react_1.useRef)(null);
    const [keyboardHeight, setKeyboardHeight] = (0, react_1.useState)(0);
    const [initialViewportHeight, setInitialViewportHeight] = (0, react_1.useState)(0);
    const isInLectureMode = localStorage.getItem('lectureMode') === 'true'; //set in the legacy code
    // Initialize viewport height reference when component mounts
    (0, react_1.useEffect)(() => {
        if (!isDesktop) {
            setInitialViewportHeight(window.innerHeight);
            const handleResize = () => {
                // If current height is less than initial height, keyboard is likely open
                if (window.innerHeight < initialViewportHeight) {
                    const detectedKeyboardHeight = initialViewportHeight - window.innerHeight;
                    setKeyboardHeight(detectedKeyboardHeight);
                }
                else {
                    setKeyboardHeight(0);
                }
            };
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [isDesktop, initialViewportHeight]);
    const saveText = (0, react_1.useCallback)(() => {
        var _a, _b;
        const updatedText = ((_b = (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.innerText) === null || _b === void 0 ? void 0 : _b.trim()) || '';
        if (updatedText !== localTextRef.current) {
            localTextRef.current = updatedText;
            tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager().updateLabelText(identifier, updatedText);
            bridge === null || bridge === void 0 ? void 0 : bridge.labelUpdate({ identifier, text: updatedText });
        }
    }, [identifier, tools, bridge]);
    // Check if the label is covered by keyboard
    const isLabelCoveredByKeyboard = (0, react_1.useCallback)(() => {
        if (isDesktop || !cardRef.current || keyboardHeight === 0)
            return false;
        const labelRect = cardRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const keyboardTop = viewportHeight - keyboardHeight;
        return labelRect.bottom > keyboardTop;
    }, [isDesktop, keyboardHeight]);
    const focusTextField = (0, react_1.useCallback)(() => {
        const element = textRef.current;
        if (element) {
            /* wait for next frame to place caret to end after focus */
            setTimeout(() => {
                element.focus();
                (0, utils_1.placeCaretAtEnd)(element);
                if (!isDesktop) {
                    setTimeout(() => {
                        if (isLabelCoveredByKeyboard()) {
                            setTopOffset(200);
                            setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(true);
                        }
                    }, 300);
                }
            }, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDesktop, isLabelCoveredByKeyboard]);
    const unfocusTextField = (0, react_1.useCallback)(() => {
        var _a;
        saveText();
        (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        setExpanded(false);
        setEditing(false);
        setTopOffset(0);
        if (!isDesktop) {
            setTimeout(() => {
                setShowLabelLines(true);
                setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(false);
            }, 100);
        }
        tools === null || tools === void 0 ? void 0 : tools.getLabelToolManager().updateUndoRedoHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identifier]);
    const onDoubleClick = (0, react_1.useCallback)(() => {
        const viewModeName = t(i18n_1.Strings.screens.viewMode);
        const screenView = document.getElementsByName(viewModeName);
        if (screenView.length > 0) {
            return;
        }
        setExpanded(true);
        focusTextField();
        setEditing(true);
        if (!isDesktop) {
            setShowLabelLines(false);
        }
        if (editable) {
            setEditing(true);
            focusTextField();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editable, focusTextField]);
    const onClickOutside = (0, react_1.useCallback)(() => {
        unfocusTextField();
        saveText();
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectLabel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unfocusTextField]);
    const onKeyDown = (event) => {
        if (event.keyCode === KeyCodes.Enter) {
            setOffsetChanged === null || setOffsetChanged === void 0 ? void 0 : setOffsetChanged(false);
            unfocusTextField();
        }
    };
    (0, react_1.useEffect)(() => {
        if (trigger) {
            saveText();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);
    (0, react_1.useEffect)(() => {
        if (trigger) {
            saveText();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);
    (0, react_1.useEffect)(() => {
        if (latestLabel !== undefined && editable && !text) {
            setEditing(true);
            setExpanded(true);
            focusTextField();
        }
        if (!isDesktop && !isInLectureMode) {
            setShowLabelLines(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsx)(StyledLabelCard, { identifier: identifier, type: bridge_schema_1.LabelType.Custom, defaultPosition: defaultPosition || { x: 0, y: 0 }, locked: locked || false, top: topOffset, onDoubleClick: onDoubleClick, onClickOutside: onClickOutside, "data-e2e": 'CustomLabelCard_StyledLabelCard', children: (0, jsx_runtime_1.jsx)(Text, { ref: textRef, "$selected": (isSelected && !isEditing) || false, "$expanded": isExpanded, "$placeholderNotActive": (0, ui_1.isTouchEventsSupported)()
                ? t(i18n_1.Strings.tools.labels.placeholderNotActiveTouch)
                : t(i18n_1.Strings.tools.labels.placeholderNotActive), contentEditable: editable || isEditing, placeholder: t(i18n_1.Strings.tools.labels.placeholder) || '', dangerouslySetInnerHTML: { __html: text || '' }, onKeyDown: onKeyDown, onBlur: unfocusTextField, "data-e2e": 'CustomLabelCard_Text' }) }));
}
exports.default = CustomLabelCard;
const StyledLabelCard = (0, styled_components_1.default)(LabelCards_1.default) `
  ${({ top }) => top !== 0 &&
    (0, styled_components_1.css) `
      top: ${top}px;
    `};
`;
const Text = styled_components_1.default.div `
  color: ${({ theme, $selected }) => $selected ? theme.text : theme.textSecondary};

  display: ${({ $expanded }) => ($expanded ? 'initial' : '-webkit-box')};
  flex-grow: 1;

  min-height: 3em;
  max-height: ${({ $expanded }) => ($expanded ? 'unset' : '5em')};

  margin: 10px;
  padding: 0;

  font-weight: ${({ $selected }) => ($selected ? '800' : '400')};
  font-size: 16px;

  outline: none;

  user-select: text;

  ${({ $expanded }) => $expanded
    ? ''
    : (0, styled_components_1.css) `
          overflow: hidden;

          text-overflow: ellipsis;

          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        `};

  &:empty::after {
    color: ${({ theme }) => theme.textPlaceholder};

    content: attr(placeholder);
  }

  &:empty:not(:focus)::after {
    color: ${({ theme }) => theme.textPlaceholder};

    content: '${({ $placeholderNotActive }) => $placeholderNotActive}';
  }
`;
